import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import EnhancedThemeProvider from 'components/EnhancedThemeProvider';
import AnnualTicketForm from '../components/AnnualTicketForm';

// GraphQL mutation for creating annual ticket (V2)
const CREATE_ANNUAL_TICKET_V2 = gql`
  mutation CreateAnnualTicketV2($input: CreateAnnualTicketInputV2!) {
    createAnnualTicketV2(input: $input) {
      id
      name
    }
  }
`;

const AddAnnualTicketContent = () => {
  const history = useHistory();
  const location = useLocation();
  const [saving, setSaving] = useState(false);

  // Get account_id from URL params
  const searchParams = new URLSearchParams(location.search);
  const accountId = searchParams.get('account_id');

  // Determine route prefix for navigation
  const { pathname } = location;
  const isTrackAdmin = pathname?.includes('admin-track');
  const isEmployeeAdmin = pathname?.includes('admin-employee');
  const routePrefix = isTrackAdmin
    ? '/admin-track'
    : isEmployeeAdmin
    ? '/admin-employee'
    : '/admin';

  // Mutation
  const [createAnnualTicketV2] = useMutation(CREATE_ANNUAL_TICKET_V2);

  const handleSubmit = async (formData) => {
    setSaving(true);

    try {
      const { data } = await createAnnualTicketV2({
        variables: {
          input: {
            ...formData,
            account_id: accountId ? parseInt(accountId) : null,
          },
        },
      });

      if (data?.createAnnualTicketV2) {
        // Preserve account_id in redirect URL
        const redirectUrl = accountId
          ? `${routePrefix}/annualTickets?account_id=${accountId}`
          : `${routePrefix}/annualTickets`;

        history.push({
          pathname: redirectUrl.split('?')[0],
          search: accountId ? `?account_id=${accountId}` : '',
          state: {
            toaster: {
              type: 'success',
              title: 'Ticket Created',
              message: `"${formData.name}" has been created successfully.`,
            },
          },
        });
      }
    } catch (error) {
      setSaving(false);
      throw error; // Re-throw to let the form handle the error display
    }
  };

  const handleCancel = () => {
    const backUrl = accountId
      ? `${routePrefix}/annualTickets?account_id=${accountId}`
      : `${routePrefix}/annualTickets`;
    history.push(backUrl);
  };

  return (
    <AnnualTicketForm
      mode="add"
      initialData={null}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      saving={saving}
      accountId={accountId}
    />
  );
};

// Wrap with theme provider
const AddAnnualTicket = () => (
  <EnhancedThemeProvider>
    <AddAnnualTicketContent />
  </EnhancedThemeProvider>
);

export default AddAnnualTicket;
